export default "__VITE_ASSET__B0z69xA2__"